let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4tyFx")).then(() => parcelRequire('dLePC'));